/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MarketingTrendRowData } from './MarketingTrendRowData';
import {
    MarketingTrendRowDataFromJSON,
    MarketingTrendRowDataFromJSONTyped,
    MarketingTrendRowDataToJSON,
    MarketingTrendRowDataToJSONTyped,
} from './MarketingTrendRowData';

/**
 * 
 * @export
 * @interface MarketingTrendsData
 */
export interface MarketingTrendsData {
    /**
     * 
     * @type {Array<MarketingTrendRowData>}
     * @memberof MarketingTrendsData
     */
    rows?: Array<MarketingTrendRowData>;
}

/**
 * Check if a given object implements the MarketingTrendsData interface.
 */
export function instanceOfMarketingTrendsData(value: object): value is MarketingTrendsData {
    return true;
}

export function MarketingTrendsDataFromJSON(json: any): MarketingTrendsData {
    return MarketingTrendsDataFromJSONTyped(json, false);
}

export function MarketingTrendsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingTrendsData {
    if (json == null) {
        return json;
    }
    return {
        
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(MarketingTrendRowDataFromJSON)),
    };
}

export function MarketingTrendsDataToJSON(json: any): MarketingTrendsData {
    return MarketingTrendsDataToJSONTyped(json, false);
}

export function MarketingTrendsDataToJSONTyped(value?: MarketingTrendsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(MarketingTrendRowDataToJSON)),
    };
}

